import React from 'react';
import { Header, Table } from 'semantic-ui-react';


const InvoiceProductsGrid = ({ mydata }) => {


    return (
        <Table size='small' textAlign='center' celled className='border-2 customBorder '>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell  className='bg-dgrey'>#</Table.HeaderCell>
                    <Table.HeaderCell  className='bg-dgrey' width={4}>
                        <Header size='tiny'>کالا و خدمات</Header>
                    </Table.HeaderCell>
                    <Table.HeaderCell  className='bg-dgrey' >
                        <Header size='tiny'>شرح</Header>
                    </Table.HeaderCell>
                    <Table.HeaderCell  className='bg-dgrey'>
                        <Header size='tiny'>واحد</Header>
                    </Table.HeaderCell>
                    <Table.HeaderCell  className='bg-dgrey'>
                        <Header size='tiny'>تعداد</Header>
                    </Table.HeaderCell>
                    <Table.HeaderCell  className='bg-dgrey'>
                        <Header size='tiny'>مبلغ واحد (ریال)</Header>
                    </Table.HeaderCell>
                    <Table.HeaderCell  className='bg-dgrey'>
                        <Header size='tiny'>تخفیف (ریال)</Header>
                    </Table.HeaderCell>
                    <Table.HeaderCell  className='bg-dgrey'>
                        <Header size='tiny'>مبلغ کل (ریال)</Header>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {
                    mydata.sale.saleDetails.map((item, index) => {
                            return item.isaddon == false ? <Table.Row key={index}>
                            <Table.Cell>{index + 1}</Table.Cell>
                            <Table.Cell>{item.service && item.service.name ? item.service.name : item.description}</Table.Cell>
                            <Table.Cell>{item.description}</Table.Cell>
                            <Table.Cell>{item.unit}</Table.Cell>
                            <Table.Cell>{item.count}</Table.Cell>
                            <Table.Cell>{Number(item.price).toLocaleString()}</Table.Cell>
                            <Table.Cell>{Number(item.discount).toLocaleString()}</Table.Cell>
                            <Table.Cell>{Number(item.total).toLocaleString()}</Table.Cell>
                        </Table.Row> : null
                        
                    
                    })
                }

            </Table.Body>
        </Table>

    );
}
export default InvoiceProductsGrid
